import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isAdminAuthed } from './AdminLoginGate';

function Spinner() {
  return (
    <div className="min-h-screen bg-[#0D0D0D] flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-[#FF1744] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

/**
 * Router-level guard for all /admin/* routes.
 * Allows access if:
 *   - Supabase session exists and the user is an authorized admin (new auth)
 *   - Legacy sessionStorage flag is set (old password auth, kept during transition)
 */
export function AdminRoute() {
  const { session, adminUser, loading, unauthorized, serviceUnavailable } = useAuth();

  if (loading) return <Spinner />;

  // Service unavailable is temporary — redirect to login so user can see the message
  if (serviceUnavailable) return <Navigate to="/admin/login" replace />;

  if (unauthorized) {
    return (
      <div className="min-h-screen bg-[#0D0D0D] flex items-center justify-center p-4">
        <div className="text-center max-w-sm">
          <p className="text-[#E0E0E0] text-lg font-semibold mb-2">Access Denied</p>
          <p className="text-gray-400 text-sm mb-6">
            Your Google account is not authorized to access GameFix Admin.
          </p>
          <a href="/admin/login" className="text-[#FF1744] hover:text-[#FF4D6D] text-sm underline">
            Back to Login
          </a>
        </div>
      </div>
    );
  }

  // New Supabase auth path
  if (session && adminUser) return <Outlet />;

  // Legacy password auth path (kept during transition period)
  if (isAdminAuthed()) return <Outlet />;

  return <Navigate to="/admin/login" replace />;
}
